import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { CapacityModelService } from "./../services/CapacityModel-Service";
import { ResponseMsg } from "./../common/response-message";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidateDataService } from "./../services/validate-data.service";
import { StaffSecurityRoleData } from "./../models/cm-model";
import { AuthHelper } from './../services/authHelper';
import {
  SohoModalDialogService, SohoBusyIndicatorDirective,
  SohoMessageRef, SohoNotificationService, SohoFileUploadComponent
} from "ids-enterprise-ng";

import { DatePipe } from '@angular/common';
import { UserData } from '../shared/models/user.model';



@Component({
  selector: 'app-edit-access-controller',
  templateUrl: './edit-access-controller.component.html',
  styleUrls: ['./edit-access-controller.component.css'],
  providers: [DatePipe]
})

export class EditAccessControllerComponent implements OnInit {
  dialog!: SohoMessageRef;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  @ViewChild(SohoFileUploadComponent, { static: true }) fileupload?: SohoFileUploadComponent;
  placeholder!: ViewContainerRef;

  isvalid!: boolean;
  public getTodaysDate!: Date;
  public getDate?: string;
  emailAddress!: string;
  userData = new UserData();
  message = 'Loading...';
  delay = 5;
  transparentOverlay = true;
  uniqueID: string = "0";
  //uniqueID: string = "";


  public ObjResponse: any;
  public context = this;
  public UploadTypeToolTip = ResponseMsg.UploadTypeToolTip;
  public ProjectTitle = "UserAccessDetails";
  public disableAll: boolean = false;

  constructor(
    private capacityModelService: CapacityModelService,
    private validateService: ValidateDataService,
    public model: StaffSecurityRoleData,
    public responsemodel: StaffSecurityRoleData,
    private modalDialog: SohoModalDialogService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private authhelper: AuthHelper,
    private notificationService: SohoNotificationService
  ) { }

  ngOnInit(): void {
    Soho.Locale.set('en-US');
    this.showNotification();
    if(this.route)
    {
      this.route.queryParams.subscribe(params => {
        this.uniqueID = params["uniqueid"];
      });
    }
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData != null && this.userData != undefined) {
      this.emailAddress = this.userData.Email;
      this.GetUserDetails();
    }
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }
  stop() {
    (this.busyIndicator as any).activated = false;
  }
  GetUserDetails() {
    this.start();
    this.capacityModelService.GetAccessDetailsforSigle(this.uniqueID).subscribe(
      StaffSecurityRoleData => {
        this.model = StaffSecurityRoleData;
        //this.model.staffid = this.datePipe.transform(this.staffid,)!;
        this.disableAll = true;
        this.stop();
      },
      (error: Response) => {
        this.AddErrorDetails(error);
        this.stop();
      }
    );
  }
  showNotification() {
    this.notificationService.show({
      parent: "#notification",
      message:
        "This page is used to Edit the data.",
      type: "info",
      linkText: "",
      link: "",
    });
    this.getTodaysDate = new Date();
    this.getDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy')!;
  }
  LoadBusyIndicator() {
    (this.busyIndicator as any).activated = true;
    setTimeout((_f: any) => (this.busyIndicator as any).activated = false, 20000);
  }
  RemoveError(id: string) {
    $("#" + id).removeMessage().removeError();
  }
  Cancel() {
    // $("#UploadDetails").removeClass("is-selected");
    this.router.navigate(["EditAccess"]);
  }
  CloseBusyIndicator() {
    (this.busyIndicator as any).activated = false;
  }
  ShowErrorAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }

  ShowAlert(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
              this.ResetModel();
              this.router.navigate(["EditAccessController"]);
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ShowErrorMessage(Message: string, Title: string) {
    const dialogRef1 = this.modalDialog
      .message("<h2>" + Message + "</h2>")
      .buttons(
        [
          {
            text: 'Ok', click: () => {
              dialogRef1.close('Ok');
            }, isDefault: true
          }
        ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }
  ResetModel() {
    let fields: string[] = [
      'emailaddress',
      'securityroleid',
      'createdby',
      'staffid',
      'securityroledescription',
      'uniqueid'
    ];
    for (let objField of fields) {
      $("#" + objField).removeError();
    }

    this.model.emailaddress = "";
    this.model.securityroleid = 0;
    this.model.createdby = "";
    this.model.securityroledescription = "";
    this.model.staffid =0;
    this.model.uniqueid =0;
  }

  UpdateAcessDetails() {
    this.model.createdby = this.emailAddress == null ? "Satyanarayana.pagidoju@infor.com" : this.emailAddress;
    this.isvalid = true;

    let errormessage: string;

    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['emailaddress', 'securityroleid', 'staffid','createdby','uniqueid']);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    // if (this.isvalid) {
    //   errormessage = this.validateService.validateDetailedQuotaForm(this.model)
    //   if (errormessage.length > 0) {
    //     this.ShowErrorMessage(errormessage, 'Error');
    //     this.isvalid = false;
    //   }
    // }
    if (this.isvalid) {
      this.start();
      this.capacityModelService.UpdateAcessDetails(this.model).subscribe(
        response => {
          this.stop();
          if(response.Status == 200) {
            this.ShowAlert("Acess Details updated successfully.", ResponseMsg.Success);
          }
          else {
            this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
          }
        },
        (error: Response) => {
          this.stop();
          this.AddErrorDetails(error);
          this.ShowAlert("Error Occured while updating the Quota.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }
  DeactiveUser() {
    this.model.createdby = this.emailAddress == null ? "Satyanarayana.pagidoju@infor.com" : this.emailAddress;
    this.isvalid = true;

    let errormessage: string;

    let errorFields: string[];
    errorFields = [];
    errorFields = this.validateService.validateFormFields(this.model, ['emailaddress', 'securityroleid', 'staffid','createdby','uniqueid','active']);

    if (errorFields.length > 0) {
      for (let objField of errorFields) {
        $("#" + objField)
          .removeError()
          .addError({ message: ResponseMsg.Required, showTooltip: true });
        this.isvalid = false;
      }
    }
    // if (this.isvalid) {
    //   debugger;
    //   errormessage = this.validateService.validateDetailedQuotaForm(this.model)
    //   if (errormessage.length > 0) {
    //     this.ShowErrorMessage(errormessage, 'Error');
    //     this.isvalid = false;
    //   }
    // }
    if (this.isvalid) {
      this.start();
 
      this.capacityModelService.DeactiveUser(this.model).subscribe(
        response => {
          this.stop();
          if(response.Status == 200) {

            this.ShowAlert("Access Details updated successfully.", ResponseMsg.Success);
          }
          else {

            this.ShowAlert("Error occured", ResponseMsg.ErrorMsg);
          }
        },
        (error: Response) => {
          this.stop();
          this.AddErrorDetails(error);
          this.ShowAlert("Error Occured while updating the Quota.", ResponseMsg.ErrorMsg);
        }
      );
    }
  }
  AddErrorDetails(error: Response) {
  }

}

